import { ElementOptions } from "@citychallenge/common";
import { getExposedInlets, getExposedOutlet } from "../reactive";

export function defineElement<N extends string, P, O extends string = string>(
  name: N,
  props: new () => P,
  options: ElementOptions<O> = {}
) {
  const inlets = getExposedInlets(props.prototype);
  const outlets = getExposedOutlet(props.prototype);

  return {
    name,
    props,
    options,
    inlets,
    outlets,
  };
}
